import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader, Text } from "@sundae/ui-toolkit";
import cx from "classnames";
import Motion from "../Motion/index.js";
const LoadingComponent = ({ label, size = "medium", className, ...rest }) => {
    return (_jsxs(Motion, { className: cx("flex h-full flex-col items-center justify-center gap-6", className), ...rest, children: [label && (_jsx(Text, { size: "sm", tag: "span", children: label })), _jsx(Loader, { size: size })] }));
};
export default LoadingComponent;
//# sourceMappingURL=LoadingComponent.js.map